/**
 * Update content based on Browser History pushes
 * @author Matt Haynes
 * @package Dunfermline
 */

import UpdateContent from './UpdateContent';

const BrowserHistory = (tourData, pageData, contentBody) => {
    let currDisplay;

    window.onhashchange = () => {
        const windowHash = window.location.hash;

        for (let i = 0, n = tourData.length; i < n; i += 1) {
            if (`#${tourData[i].slug}` === windowHash) {
                currDisplay = i;
                UpdateContent(tourData, pageData, contentBody, currDisplay);
            }
        }
    };
};

export default BrowserHistory;
